import React, {Component} from "react";
import {Form, Input, InputNumber, Select, DatePicker, Upload,} from "antd";
import moment from 'moment';
import 'moment/locale/zh-cn';
import {baseUrl} from "../../api";
import PhotoFileFormItem from "../photo-file/photo-file-form-item";

const {Option} = Select;
const EditableContext = React.createContext();
export {EditableContext}
export default class EditableCell extends Component {
    getInput = () => {
        if (this.props.inputType === 'number') {
            return <InputNumber/>;
        }
        if (this.props.inputType === 'date') {
            return <DatePicker format="YYYY-MM-DD"/>;
        }
        if (this.props.options) {
            return (
                <Select style={{width: '100%'}} allowClear>
                    {Object.keys(this.props.options).map((key) => (
                        <Option value={key} key={key}>{this.props.options[key]}</Option>
                    ))}
                </Select>
            )
        }
        return <Input/>;
    };
    getInitValue = (record, dataIndex) => {
        if (this.props.inputType === 'date' && record[dataIndex]) {
            return moment(record[dataIndex], 'YYYY-MM-DD');
        }
        if (this.props.options && dataIndex === 'entId') {
            return undefined;
        }
        return record[dataIndex];
    }
    renderCell = ({getFieldDecorator}) => {
        const {
            editing, required, dataIndex, title, inputType, record, index, children, options, ...restProps
        } = this.props;
        let value = ""
        if (record) {
            value = record[dataIndex] === null ? "" : record[dataIndex]
        }
        return (
            <td {...restProps}>
                {editing ?
                    (inputType === 'file' ?
                            <PhotoFileFormItem getFieldDecorator={getFieldDecorator} name='fileIds'
                                               initialValue={record.fileIds}
                                               fileType='import_order_box_note' orderId={record.orderId}/> :
                            <Form.Item style={{margin: 0}}>
                                {getFieldDecorator(dataIndex, {
                                    initialValue: this.getInitValue(record, dataIndex),
                                    rules: [
                                        {
                                            required: required,
                                            message: `请输入 ${title.replace('* ', '')}!`,
                                        },
                                    ],
                                })(this.getInput())}
                            </Form.Item>
                    ) : (children)}
            </td>
        );
    };

    render() {
        return <EditableContext.Consumer>{this.renderCell}</EditableContext.Consumer>;
    }
}